import React, { useState } from 'react';
import Sidebar from 'components/Sidebar';
import MobileHeader from 'components/MobileHeader';
import SearchOverlay from 'components/SearchOverlay';
import Container from 'components/Container';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getMcp, updateMcp } from 'api/mcps';
import TextInput from 'components/Form/TextInput';
import Button from 'components/Button';

export default function Create() {

    const [sidebar, setSidebar] = useState(false);
    const [search, setSearch] = useState(false);
    const { mcpId } = useParams();
    const cache = useQueryClient();
    const navigate = useNavigate();

    const { data: mcp } = useQuery({
        queryKey: ['mcps', mcpId],
        queryFn: async () => await getMcp({id: mcpId}),
        enabled: Boolean(mcpId),
    });

    const { mutate } = useMutation({
        mutationKey: ['createMcp'],
        mutationFn: updateMcp,
        onSuccess: (data) => {
            console.log("MCP created successfully:", data);
            cache.invalidateQueries(['mcps']);

            return navigate(`/settings/mcps/${data._id}`);
        },
        onError: (error) => {
            console.error("Error creating MCP:", error);
        }
    });

    function onSubmitHandler(formData) {
        const data = {
            name: formData.get('name'),
            description: formData.get('description'),
            baseUrl: formData.get('baseUrl'),
            apiKey: formData.get('apiKey'),
        }
        mutate({id: mcpId, data});
    }

    if(!mcp) {
        return <></>;
    }

    return (
        <>
            <Sidebar
                visible={sidebar}
                setVisible={setSidebar}
            />

            <SearchOverlay
                visible={search}
                setVisible={setSearch}
            />

            <MobileHeader
                sidebar={sidebar}
                setSidebar={setSidebar}
                search={search}
                setSearch={setSearch}
            />

            <div className={`fixed top-0 w-full bottom-0 transition-all duration-300 ease-in-out lg:pl-[320px] ${sidebar ? 'left-[80vw]' : 'left-0'}`}>
                <Container className='!min-w-[700px] !max-w-[700px]'>
                    <div className='pb-8 pt-20 md:pt-14 text-center'>
                        <p className='text-3xl'>{mcp.name}</p>
                    </div>

                    <div className=''>
                        <form action={onSubmitHandler} className='flex flex-col gap-4'>
                            <TextInput
                                label="Nome"
                                name="name"
                                placeholder="Nome"
                                defaultValue={mcp.name}
                            />

                            <TextInput
                                label="Descrizione"
                                name="description"
                                placeholder="Descrizione"
                                defaultValue={mcp.description}
                            />

                            <TextInput
                                label="Base URL"
                                name="baseUrl"
                                placeholder="Base URL"
                                defaultValue={mcp.baseUrl}
                            />

                            <TextInput
                                label="API Key"
                                name="apiKey"
                                placeholder="API Key"
                                defaultValue={mcp.apiKey}
                            />

                            <div className='flex justify-between'>
                                <Link to={`/settings/mcps/${mcpId}`} className='hover:bg-verylight text-sm font-medium px-6 py-3 rounded-md transition-colors cursor-pointer duration-200'>Annulla</Link>
                                <Button submit>Salva</Button>
                            </div>
                        </form>
                    </div>

                </Container>
            </div>
        </>
    )
}
